<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`上传总报告文件`"
    width="600px"
    height="400px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="24">
          <el-form-item label="委托编号">
            <el-input disabled :value="activeInfo.reportCodeStart" placeholder="请输入委托单编号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="项目名称">
            <el-input disabled :value="activeInfo.projectName" placeholder="请输入委托单编号" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="报告文件" prop="fileList" ref="fileFormItem" required>
            <UploadButton
              v-model="editForm.fileList"
              :limit="1"
              :fileType="['pdf', 'PDF']"
              :paramsData="{ type: 'upt_final_report' }"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
import UploadButton from '@/components/UploadArea/UploadButton';

import { editEntrustmentSetDocPath } from '@/api/entrust';

export default {
  components: { UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 报告编号
    activeInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      detailLoading: false,
      editForm: {
        fileList: []
      },
      rules: {
        fileList: [{ required: true, message: '请上传报告扫描件', trigger: 'blur' }]
      },
      submitLoading: false
    };
  },
  filters: {},
  watch: {
    visible(val) {},
    'editForm.fileList'(val) {
      if (val && val.length > 0) {
        this.$nextTick(() => {
          this.$refs.fileFormItem.clearValidate();
        });
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;

          const docPath = this.editForm.fileList?.[0]?.filePath ?? null;
          const params = {
            id: this.activeInfo.id,
            docPath
          };

          try {
            await editEntrustmentSetDocPath(params);

            this.$emit('refresh');
            this.$emit('update:visible', false);
            this.$message.success('提交成功!');
          } finally {
            this.submitLoading = false;
          }
        }
      });
    }
  },
  mounted() {}
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
